module.exports = __webpack_public_path__ + "img/sankaku_100_red.c37e8a32.png";